import { render, staticRenderFns } from "./LayoutCentered.vue?vue&type=template&id=63b4a09f&"
import script from "./LayoutCentered.vue?vue&type=script&lang=js&"
export * from "./LayoutCentered.vue?vue&type=script&lang=js&"
import style0 from "./LayoutCentered.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VContent } from 'vuetify/lib/components/VContent';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VContent,VLayout})
